import { render, staticRenderFns } from "./SetPopup.vue?vue&type=template&id=05552f22&scoped=true"
import script from "./SetPopup.vue?vue&type=script&lang=js"
export * from "./SetPopup.vue?vue&type=script&lang=js"
import style0 from "./SetPopup.vue?vue&type=style&index=0&id=05552f22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05552f22",
  null
  
)

export default component.exports